var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('modal',{ref:"modalMapa",attrs:{"titulo":"Ubicar leechero en","tamano":"modal-xl","icon":"location","no-aceptar":"","no-cancelar":""}},[_c('mapa-google',{ref:"googleMap",attrs:{"desactivar-mapa":false,"icono-central":"/img/icons/tendero-point-map.svg","dragable":true}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }